export const GET_SECURITY_LOADING_REPORTS_REQUEST = 'GET_SECURITY_LOADING_REPORTS_REQUEST' as const;
export const GET_SECURITY_LOADING_REPORTS_SUCCESS = 'GET_SECURITY_LOADING_REPORTS_SUCCESS' as const;
export const GET_SECURITY_LOADING_REPORTS_ERROR = 'GET_SECURITY_LOADING_REPORTS_ERROR' as const;

export const fieldsNames = [
  'tripId',
  'trailerLicensePlate',
  'driverDocumentNumber',
  'entryDateTime',
  'departureDateTime',
  'ordersCalculatedNetWeight',
  'ordersCalculatedGrossWeight',
  'perforationWeight',
  'departureWeight',
  'alloweWeight',
  'customer',
  'receiver',
  'forwarderName',
  'forwarderPhone',
  'securityMessage',
];
